// Nach dem Vertragsende: keine Funktionen mehr, nur der Hinweis auf die
// Datenkopie (30 Tage) und die Abmeldung. Der Server lässt ohnehin nur noch
// Anmeldung, Tarifstand und Datenkopie durch.
import { useAuth } from '../../../gemeinsam/lib/AuthContext';
import { useSprache } from '../../../gemeinsam/lib/i18n';
import { Hinweis, Knopf } from '../../../gemeinsam/komponenten/Basis';
import AuthRahmen from '../komponenten/AuthRahmen';
import Datenkopie from '../../mandanten/komponenten/Datenkopie';

const letzterTag = (s: string) => new Date(Date.parse(s) - 1).toLocaleDateString('de-DE', { timeZone: 'Europe/Berlin' });
const tag = (s: string) => new Date(s).toLocaleDateString('de-DE', { timeZone: 'Europe/Berlin' });

export default function VertragBeendet() {
  const { t } = useSprache();
  const { abo, abmelden } = useAuth();
  return (
    <AuthRahmen>
      <h1 className="text-xl font-bold text-slate-900 dark:text-slate-100">{t('abo.beendetTitel')}</h1>
      {abo?.kuendigungZum && (
        <p className="text-sm text-slate-600 dark:text-slate-400">{t('abo.beendetText').replace('{datum}', letzterTag(abo.kuendigungZum))}</p>
      )}
      {abo?.exportBis && <Hinweis art="info">{t('abo.beendetKopie').replace('{bis}', tag(abo.exportBis))}</Hinweis>}
      <Datenkopie />
      <p className="text-sm text-slate-500 dark:text-slate-400">{t('abo.aufbewahrung')}</p>
      <Knopf className="w-full" onClick={() => void abmelden()}>{t('aktion.abmelden')}</Knopf>
    </AuthRahmen>
  );
}
